import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import axios from '~/data/http/axios'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import i18n from '~/i18n'

export default function CreateOrganisation({ onCancel = () => {} }) {
    const [name, setName] = useState('')
    const [error, setError] = useState('')
    const history = useHistory()

    const create = async () => {
        setError('')
        if (!name) return setError(i18n.t('subscribers:organisations.nameRequired'))
        try {
            const res = await axios.post('/organisation', { name })
            history.push('/cp/subscribers/organisations/' + res.data.Organisation.id)
        } catch (e) {
            setError(e && e.data ? e.data.error : i18n.t('subscribers:organisations.nameInvalid'))
        }
    }

    return (
        <div>
            <h4 className='mar-b25'>{i18n.t('subscribers:organisations.createHeader')}</h4>

            <TextInput
                outerClassName='mar-b25'
                label={i18n.t('subscribers:organisations.name')}
                value={name}
                focus
                onEnterPress={create}
                onChange={(e) => setName(e.currentTarget.value)}
                error={error}
                placeholder={i18n.t('subscribers:organisations.namePlaceholder')}
            />

            <div className='quickFlex'>
                <Button
                    text={i18n.t('subscribers:organisations.createBtn')}
                    className='button-primary mar-r10'
                    onClick={create}
                    iconLeft={<Icons icon='plus' />}
                />
                <Button
                    text={i18n.t('subscribers:organisations.cancelBtn')}
                    className='grey button-sml full-width'
                    onClick={onCancel}
                />
            </div>
        </div>
    )
}
